/**
 * @Author: Ygm
 * @Date: 2024-08-07 09:08:06
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-08 09:00:50
 * @Description: 信息转办 -> 转办空间
 */
const defaultRouters = [
  {
    name: 'TransferIndex',
    path: '/infoInput/transfer',
    title: '信息转办',
    component: () => import('@/view/pages/TransferSpace/TransferIndex')
  },
  {
    name: 'TransferStatistics',
    path: '/infoInput/statistics',
    title: '转办统计',
    component: () => import('@/view/pages/TransferSpace/TransferStatistics')
  }
]

export default defaultRouters



// WEBPACK FOOTER //
// ./src/router/transferSpace.js